<app-top-nav-registration></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
    <div class="content" role="main">
        <img src="/assets/spinner.gif" class="spinner">
    </div>
</div>
<app-footer></app-footer>
